import React, {
  Fragment,
  useEffect,
  useState,
} from "react";
import {
  Col,
  Card,
  Dropdown,
} from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import * as constants from "../../../utils/Constants";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import { toast, ToastContainer } from "react-toastify";

const ListUsers = () => {
  const { state } = useLocation();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [page, setPage] = useState(
    Number(location?.pageCallBack) > 1 ? Number(location?.pageCallBack) : 1
  );
  const [sortBy, setSortBy] = useState(location?.sortByCallBack);
  const [order, setOrder] = useState(location?.orderCallBack);
  const [pageDetails, setPageDetails] = useState({});
  const [items, setItems] = useState([]);
  const history = useHistory();
  const [searchText, setSearchText] = useState(location?.searchCallBack);
  let userData = [];
  let loggedInUser = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    window.scrollTo(0, 0);
    getListUser(page - 1, searchText, sortBy, order);
  }, []);

  //popup filter
  const openFilter2 = () => {
    document.getElementById("staticBackdrop").style.display = "none";
  };
  const clearFilter = () => {
    window.location.reload();
  };
  const openFilter = () => {
    document.getElementById("staticBackdrop").style.top =
      document.getElementById("popupbox").getBoundingClientRect().y + 20 + "px";
    document.getElementById("staticBackdrop").style.left =
      document.getElementById("popupbox").getBoundingClientRect().x -
      310 +
      "px";
    document.getElementById("staticBackdrop").style.display = "block";
    if (openFilterClicked) {
      openFilter2();
      openFilterClicked = false;
    } else {
      openFilterClicked = true;
    }
  };
  var openFilterClicked = false;

  //  Filter Dropdown
  const [loginData, setLoginData] = useState({
    ...state,
    ...location?.filterDataCallback,
  });

  const statusOptions = () => {
    return [
      { label: "Active", value: "0" },
      { label: "Inactive", value: "1" },
    ];
  };

  const rolesOptions = () => {
    return [
      { label: "Admin", value: "Admin" },
      { label: "Internal Recruiter", value: "Internal Recruiter" },
      { label: "Key Account Manager", value: "Key Account Manager" },
      // { label: 'Recruitment Agent', value: 'Recruitment Agent' }
    ];
  };
  const handleRoles = (value) => {
    const newLoginData = { ...loginData };
    let rolesChange = "";
    if (value) {
      rolesChange = value[0]?.value?.toString();
      newLoginData["roles"] = rolesChange;
    } else {
      rolesChange.length = 0;
      newLoginData["roles"] = rolesChange;
    }
    setLoginData(newLoginData);
  };
  const handleStatus = (value) => {
    const newLoginData = { ...loginData };
    let statusChange = "";
    if (value) {
      statusChange = value[0]?.value?.toString();
      newLoginData["activeFlag"] = statusChange;
    } else {
      statusChange.length = 0;
      newLoginData["activeFlag"] = statusChange;
    }
    setLoginData(newLoginData);
  };
  //Filter
  const handleFilter = (value) => {
    document.getElementById("staticBackdrop").style.display = "none";
    if (location?.pageCallBack) {
      getListUser(page - 1, searchText, sortBy, order);
    } else {
      // setPage(1)
      getListUser(0, searchText, sortBy, order);
    }
  };

  function getListUser(page, search, sort, order) {
    fetch(
      `${constants.ListAllUsersUrl}?page=${page}&search=${
        search || ""
      }&sortBy=${sort || ""}&sort=${order || ""}`,
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${loggedInUser.sessionToken}`,
        },
        body: JSON.stringify(loginData || {}),
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);
          setItems(result?.data?.content);
          setPageDetails(result.data);
          setData(document.querySelectorAll("#application tbody tr"));
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }

  if (items) {
    userData = [...items];
    // console.log(userData)
  }

  const handleRowClick = (selectedRow) => {
    history.push({
      pathname: "/view-user",
      state: selectedRow,
      filterDataCallback: loginData,
      searchCallBack: searchText,
      sortByCallBack: sortBy,
      orderCallBack: order,
      pageCallBack: page,
    });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
    getListUser(value - 1, searchText, sortBy, order);
  };

  const handleSortOntable = (key, order) => {
    setSortBy(key);
    setOrder(order);
    if (location?.pageCallBack) {
      getListUser(page - 1, searchText, key, order);
    } else {
      // setPage(1)
      getListUser(0, searchText, key, order);
    }
  };

  const handleEdit = (selectedRow) => {
    // console.log("SelectedRow: " + selectedRow.state);
    history.push({
      pathname: "/create-user",
      state: selectedRow,
    });
  };

  const handleActivation = (selectedRow) => {
    var activeFlag = selectedRow.activeFlag === 1 ? "0" : "1";
    fetch(`${constants.ActiveOrDeactiveUserUrl}/${selectedRow.id}`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${loggedInUser.sessionToken}`,
      },
      body: JSON.stringify({ activeFlag: activeFlag }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res != null) {
          getListUser(0, searchText, sortBy, order);
        }
        if (res.message) {
            if (res.message.messageCode) {
              toast.success(`✅ ${res.message.messageDescription} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            }
          } else if (res.error) {
            if (res.error.errorCode) {
              toast.error(`❌ ${res.error.errorMessage} !`, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            }
          }
      });
  };

  useEffect(() => {
    handleSearch(searchText);
  }, [searchText]);

  const handleSearch = (search) => {
    if (location?.pageCallBack) {
      getListUser(page - 1, search || searchText, sortBy, order);
    } else {
      setPage(1);
      getListUser(0, search || searchText, sortBy, order);
    }
  };

  const [data, setData] = useState(
    document.querySelectorAll("#application tbody tr")
  );

  const [test, settest] = useState(0);

  // use effect
  useEffect(() => {
    setData(document.querySelectorAll("#application tbody tr"));
    chackboxFun();
  }, [test]);

  // Active pagginarion
  // activePag.current === 0 && chageData(0, pageEntries)
  // paggination
  // let paggination = Array(Math.ceil(data.length / pageEntries))
  //     .fill()
  //     .map((_, i) => i + 1)

  // Active paggination & chage data
  // const onClick = (i) => {
  //     activePag.current = i
  //     chageData(activePag.current * pageEntries, (activePag.current + 1) * pageEntries)
  //     settest(i)
  // }
  const chackbox = document.querySelectorAll(".application_sorting_1 input");
  const motherChackBox = document.querySelector("#checkAll");

  const chackboxFun = (type) => {
    for (let i = 0; i < chackbox.length; i++) {
      const element = chackbox[i];
      if (type === "all") {
        if (motherChackBox.checked) {
          element.checked = true;
        } else {
          element.checked = false;
        }
      } else {
        if (!element.checked) {
          motherChackBox.checked = false;
          break;
        } else {
          motherChackBox.checked = true;
        }
      }
    }
  };

  return (
    <Fragment>
      <div className="d-flex flex-wrap mb-4">
        <div className="mr-auto mb-2 pr-2 show-results">
          <h6 className="text-black fs-16 font-w600 mb-1">
            Showing {pageDetails?.totalElements} User Results
          </h6>
          <span className="fs-14">Based your preferences</span>
        </div>
        <div className="d-flex flex-wrap mb-l3 mb-s1">
          <div className="input-group search-area d-xl-inline-flex">
            <input
              type="text"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
              className="form-control input-rounded mr-auto mb-md-0 mb-3"
              placeholder="Search here..."
            />
            <div className="input-group-append">
              <span className="input-group-text">
                <i
                  className="flaticon-381-search-2"
                  onClick={handleSearch}
                  style={{ cursor: "pointer" }}
                />
              </span>
            </div>
          </div>
        </div>{" "}
        &nbsp;&nbsp;
        {/* Filter  */}
        <div className="d-flex flex-wrap mb-3">
          <div>
            <div className="dropdown custom-dropdown mb-0 mt-3 mt-sm-0 mb-1">
              <button
                className="btn btn-primary"
                id="popupbox"
                onClick={openFilter}
                data-bs-toggle="modal"
                data-bs-target="#staticBackdrop"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="18"
                  fill="currentColor"
                  class="bi bi-filter-square"
                  viewBox="0 0 16 16"
                >
                  {" "}
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />{" "}
                  <path d="M6 11.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z" />{" "}
                </svg>{" "}
                Filter
              </button>
              {/* popup */}
              <div>
                <div
                  className="modal fade show"
                  id="staticBackdrop"
                  style={{ width: "400px", height: "63%", top: 100, left: 503 }}
                  data-bs-backdrop="static"
                  data-bs-keyboard="false"
                  tabIndex="-1"
                  aria-labelledby="staticBackdropLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                      <div
                        className=""
                        style={{
                          overflowY: "scroll",
                          width: "400px",
                          height: "250px",
                        }}
                      >
                        <div>
                          {/* className="modal-header" */}
                          <Col lg={12}>
                            <Card>
                              <Card.Body>
                                <h4>
                                  <b>Filter User</b>
                                </h4>
                                <br></br>
                                <div className="row">
                                  <div className="col-xl-6">
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Status"
                                        options={statusOptions()}
                                        onChange={(value) => {
                                          handleStatus(value);
                                        }}
                                      />
                                    </div>
                                  </div>
                                  <br />
                                  <div className="col-xl-6">
                                    <div form-group row>
                                      <ReactMultiSelectCheckboxes
                                        placeholderButtonLabel="Roles"
                                        options={rolesOptions()}
                                        onChange={(value) => {
                                          handleRoles(value);
                                        }}
                                      ></ReactMultiSelectCheckboxes>
                                    </div>
                                  </div>
                                </div>{" "}
                                <div></div>
                                <br></br>
                                <br></br>
                                <button
                                  type="button"
                                  onClick={clearFilter}
                                  className="btn btn-primary"
                                >
                                  Clear
                                </button>
                                &nbsp;&nbsp;
                                <button
                                  type="button"
                                  onClick={handleFilter}
                                  className="btn btn-primary"
                                >
                                  Apply
                                </button>
                                &nbsp;&nbsp;
                                <br></br>
                              </Card.Body>
                            </Card>
                          </Col>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        &nbsp;&nbsp;
        {/* Sort By */}
        {/* <div className="d-flex flex-wrap mb-3">
                    <DropdownButton
                        id="dropdown-basic-button"
                        variant="primary"
                        className="dropdown custom-dropdown mb-0 mr-4 mt-3 mt-sm-0 mb-1"
                        onSelect={handleSorting}
                        title={sorting?.key || "Sort By"}
                        style={{ color: '#00ADEE' }}
                    >
                        {sortList.map((item, index) => {
                            return (
                                <Dropdown.Item key={index} eventKey={item.value} onClick={() => handleSort(item.key)}>
                                    {item.value}
                                </Dropdown.Item>
                            );
                        })}
                    </DropdownButton>
                </div> */}
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="table-responsive">
            <div id="application" className="dataTables_wrapper no-footer">
              {!userData?.length > 0 ? (
                <div>
                  <Box className="card" sx={{ width: "100%" }}>
                    <LinearProgress />
                  </Box>
                </div>
              ) : !items || userData?.length <= 0 ? (
                <div>No records found</div>
              ) : (
                <table
                  className="table display mb-4 dataTablesCard table-responsive-xl card-table dataTable no-footer"
                  id="example5"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Name</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("userName", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("userName", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Email Id</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc"
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("emailId", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("emailId", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Role</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("roles", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("roles", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Employee Id</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("employeeId", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("employeeId", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Status</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          >
                            <i
                              class="fa fa-sort-asc "
                              style={{
                                padding: "0px",
                                height: "8px",
                                marginTop: "3px",
                              }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("activeFlag", "asc");
                              }}
                            ></i>
                            <i
                              class="fa fa-sort-desc"
                              style={{ height: "8px", marginTop: "-3px" }}
                              type="button"
                              onClick={() => {
                                handleSortOntable("activeFlag", "desc");
                              }}
                            ></i>
                          </div>
                        </div>
                      </th>
                      <th
                        className="sorting"
                        style={{ width: "100px", border: "none" }}
                      >
                        <div
                          class="row"
                          style={{
                            flexWrap: "unset",
                            justifyContent: "center",
                          }}
                        >
                          <span>Action</span>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "20px",
                              marginLeft: "10px",
                              alignItems: "flex-start",
                            }}
                          ></div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {userData?.map((user) => (
                      <tr
                        role="row"
                        style={{ cursor: "pointer" }}
                        className="odd"
                      >
                        <td onClick={() => handleRowClick(user)}>
                          {user.userName}
                        </td>
                        <td onClick={() => handleRowClick(user)}>
                          {user.emailId}
                        </td>
                        <td onClick={() => handleRowClick(user)}>
                          {user.roles}
                        </td>
                        <td onClick={() => handleRowClick(user)}>
                          {user?.employeeId !== "null" ? user.employeeId : ""}
                        </td>
                        {/* <td onClick={() => handleRowClick(user)}>{user.status}</td> */}

                        <td onClick={() => handleRowClick(user)}>
                          <div>
                            <button
                              style={{
                                border: "none",
                                padding: "5px 10px ",
                                // backgroundColor: user.status === 'Deactivate' ? '1' : user.status === 'Active' ? '0' : '',
                                textAlign: "center",
                              }}
                              type="button"
                              className="btn btn-primary btn-md"
                            >
                              {user?.activeFlag === 0 ? "Active" : "Inactive"}
                            </button>
                          </div>
                        </td>

                        <td>
                          <div className="d-flex align-items-center">
                            <Dropdown className="dropdown float-right custom-dropdown mb-0">
                              <Dropdown.Toggle
                                className="i-false"
                                data-toggle="dropdown"
                                variant=""
                              >
                                <svg
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                                    stroke="#2E2E2E"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                                    stroke="#2E2E2E"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                                    stroke="#2E2E2E"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </Dropdown.Toggle>
                              <Dropdown.Menu className="dropdown-menu dropdown-menu-right">
                                <Dropdown.Item
                                  className="dropdown-item"
                                  onClick={() => handleEdit(user)}
                                >
                                  Edit
                                </Dropdown.Item>
                                <Dropdown.Item
                                  className="dropdown-item"
                                  onClick={() => handleActivation(user)}
                                >
                                  {user?.activeFlag === 0
                                    ? "Deactivate User"
                                    : "Activate User"}
                                </Dropdown.Item>
                                <Dropdown.Item className="dropdown-item text-danger">
                                  Cancel
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info" id="example5_info">
                  Page: {page}
                </div>
                <div>
                  <Pagination
                    count={pageDetails?.totalPages}
                    page={page}
                    onChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default ListUsers;
